<template>
  <div class="auth-tree">
    <el-tree
      ref="userAuthTree"
      node-key="id"
      :data="list"
      :props="defaultProps"
      highlight-current
      show-checkbox
      :default-expanded-keys="selectUserAuth"
      :default-checked-keys="selectUserAuth"
      @check="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{ node }">
        <span>
          <span>{{ node.label }}</span>
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  // selectUserAuth: 所拥有的权限
  props: ['list', 'selectUserAuth'],

  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name"
      }
    }
  },

  created() {
  },

  methods: {
    handleNodeClick() {
      let res = this.$refs.userAuthTree.getCheckedNodes(true, true);
      this.$emit('getSetTree', res)
    }
  }
}
</script>

<style lang='scss'>
</style>